export enum Pages {
    FORMS_LIST = 'FORMS_LIST',
    FORMS_RESPONSE = 'FORMS_RESPONSE',
    CREATE_FORM = 'CREATE_FORM',
    PROP_FORM = 'PROP_FORM',
    RESULTS_FORM = 'RESULTS_FORM',
    EMPTY_RESULTS = 'EMPTY_RESULTS',
    EDIT_FORM = 'EDIT_FORM',
    VISUALIZE_FORM = 'VISUALIZE_FORM',
    RESPOND_QUESTION = 'RESPOND_QUESTION',
    RECAP_QUESTIONS = 'RECAP_QUESTIONS',
    PREVIEW = 'PREVIEW',
    RGPD_QUESTIONS = 'RECAP_QUESTIONS',
    E403 = 'E403',
    E404 = 'E404',
    E409 = 'E409'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/formulaire-pages.ts